let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kNBKo")).then(() => parcelRequire('jypAT'));